import React, { Component, PropTypes } from 'react';
import { GridList, GridTile } from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import CheckBoxIcon from 'material-ui/svg-icons/toggle/check-box';
import CheckBoxOutlineBlankIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import _ from 'lodash';

class PhotoLibrary extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <GridList
          cellHeight={147}
          cols={3}
        >
          {_.map(this.props.photos, (photo, index) => (
            <GridTile
              key={index}
              title={photo.title || ' '} //If no title, no overlay background
              actionIcon={
                <IconButton
                  onClick={this.props.onSelected.bind(this, photo)}>
                  {_.find(this.props.selected, { _id: photo._id }) ?
                    <CheckBoxIcon
                      color="white" />
                    :
                    <CheckBoxOutlineBlankIcon
                      color="white" />
                  }
                </IconButton>
              }
            >
              <img src={photo.url} />
            </GridTile>
          ))}
        </GridList>
      </div>
    )
  }
}

PhotoLibrary.propTypes = {
  photos: PropTypes.array,
  selected: PropTypes.array,
  onSelected: PropTypes.func,
};

PhotoLibrary.defaultProps = {
  photos: [],
  selected: [],
  onSelected: () => {
  },
};

export default PhotoLibrary;


// WEBPACK FOOTER //
// client/adminPanel/panel/displays/PhotoLibrary.js